<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><span>Contents</span></p>
<p class="contents"><a href="#/007_Chapter_01">Nothing Missing but the Samovar</a></p>
<p class="contents"><a href="#/008_Chapter_02">The Voice of God in Adelaide Terrace</a></p>
<p class="contents"><span href="#/009_Chapter_03" title="Link target outside of Sample">Interpreting the Past</span></p>
<p class="contents"><span href="#/010_Chapter_04" title="Link target outside of Sample">Servants Talk About People: Gentlefolk Discuss Things</span></p>
<p class="contents"><span href="#/011_Chapter_05" title="Link target outside of Sample">Help</span></p>
<p class="contents"><span href="#/012_Chapter_06" title="Link target outside of Sample">Miss Carlton and the Pop Concert</span></p>
<p class="contents"><span href="#/013_Chapter_07" title="Link target outside of Sample">Revenant as Typewriter</span></p>
<p class="contents"><span href="#/014_Chapter_08" title="Link target outside of Sample">Next Term, We'll Mash You</span></p>
<p class="contents"><span href="#/015_Chapter_09" title="Link target outside of Sample">At the Pitt-Rivers</span></p>
<p class="contents"><span href="#/016_Chapter_10" title="Link target outside of Sample">Nice People</span></p>
<p class="contents"><span href="#/017_Chapter_11" title="Link target outside of Sample">A World of Her Own</span></p>
<p class="contents"><span href="#/018_Chapter_12" title="Link target outside of Sample">Presents of Fish and Game</span></p>
<p class="contents"><span href="#/019_Chapter_13" title="Link target outside of Sample">A Clean Death</span></p>
<p class="contents"><span href="#/020_Chapter_14" title="Link target outside of Sample">Party</span></p>
<p class="contents"><span href="#/021_Chapter_15" title="Link target outside of Sample">Corruption</span></p>
<p class="contents"><span href="#/022_Chapter_16" title="Link target outside of Sample">Venice, Now and Then</span></p>
<p class="contents"><span href="#/023_Chapter_17" title="Link target outside of Sample">Grow Old Along With Me, the Best Is Yet To Be</span></p>
<p class="contents"><span href="#/024_Chapter_18" title="Link target outside of Sample">The Darkness Out There</span></p>
<p class="contents"><span href="#/025_Chapter_19" title="Link target outside of Sample">The Pill-Box</span></p>
<p class="contents"><span href="#/026_Chapter_20" title="Link target outside of Sample">Customers</span></p>
<p class="contents"><span href="#/027_Chapter_21" title="Link target outside of Sample">Yellow Trains</span></p>
<p class="contents"><span href="#/028_Chapter_22" title="Link target outside of Sample">‘The Ghost of a Flea’</span></p>
<p class="contents"><span href="#/029_Chapter_23" title="Link target outside of Sample">The Art of Biography</span></p>
<p class="contents"><span href="#/030_Chapter_24" title="Link target outside of Sample">What the Eye Doesn't See</span></p>
<p class="contents"><span href="#/031_Chapter_25" title="Link target outside of Sample">The Emasculation of Ted Roper</span></p>
<p class="contents"><span href="#/032_Chapter_26" title="Link target outside of Sample">A Long Night at Abu Simbel</span></p>
<p class="contents"><span href="#/033_Chapter_27" title="Link target outside of Sample">Bus-Stop</span></p>
<p class="contents"><span href="#/034_Chapter_28" title="Link target outside of Sample">Clara's Day</span></p>
<p class="contents"><span href="#/035_Chapter_29" title="Link target outside of Sample">The French Exchange</span></p>
<p class="contents"><span href="#/036_Chapter_30" title="Link target outside of Sample">The Dream Merchant</span></p>
<p class="contents"><span href="#/037_Chapter_31" title="Link target outside of Sample">Pack of Cards</span></p>
<p class="contents"><span href="#/038_Chapter_32" title="Link target outside of Sample">The Crimean Hotel</span></p>
<p class="contents"><span href="#/039_Chapter_33" title="Link target outside of Sample">A Dream of Fair Women</span></p>
<p class="contents"><span href="#/040_Chapter_34" title="Link target outside of Sample">Black Dog</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Contents.vue?ef52cdf0